import React from 'react';
import {Separator} from 'src/common-components/atoms';

const BehaviorSeparator = () => {
  return <Separator width={20} />;
};

export default BehaviorSeparator;
